import * as React from "react"
import { Server } from "stellar-sdk"
import albedo from '@albedo-link/intent'
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"




const IndexPage = () => {

  const [error, setError] = React.useState("");
  const [publicKey, setPublicKey] = React.useState("");
  const [balance, setBalance] = React.useState("0.00");


  const login = async () => {
    setError("")
    try {
      const pubKeyRes = await albedo.publicKey();
      setPublicKey(pubKeyRes.pubkey)
      const server = new Server("https://horizon.stellar.org")
      const account = await server.loadAccount(pubKeyRes.pubkey);
      console.log(account)
      const strBalance = (account.balances.find((balance) =>
          balance.asset_type !== "native" &&
          balance.asset_code === "HAPPYCOIN" &&
          balance.asset_issuer === "GAKLB4ON7CWXPXV4IKRJ75ISNH6CSBDMKEV4JDUCV5NMDU27VIVZVV32"
        ) || { balance: "0.00" }
      ).balance;
      setBalance(Number(strBalance).toFixed(2));
    } catch (e) {
      setError("Algo ha fallado")
    }

  };

  // React.useEffect(() => {
  //   async function fetchAccountData() {
  //     const server = new StellarSdk.Server("https://horizon.stellar.org");
  //     const account = await server.loadAccount("GDBUV3IVEBTVGAGRFU4Z5MUHKL2ZVJUEYXVIRMPZRYV7HFVRCIGNZQ6X");
  //     console.log(account.balances)
  //   }
  //   fetchAccountData()
  // }, [])

  return <Layout>
    <Seo title="HappyCoin" />
    {error && <div className="error">{error}</div>}
    {publicKey && <div className="logged-in">
      <div className="publicKey">{publicKey}</div>
      <div className="balance">
      <StaticImage
        src="../images/happycoin.png"
        width={48}
        alt="HAPPYCOIN"
    />
     <span>{balance}</span>
      </div>
    </div>}
    {!publicKey && <button onClick={() => login()}>Login</button>}
  </Layout>
}

export default IndexPage
